module.exports = __webpack_public_path__ + "img/dcdb4dc.png";